// extracted by mini-css-extract-plugin
export default {"column":"RevenueFilter_column__rCvdY","boxCSV":"RevenueFilter_boxCSV__sEhsu"};